import { render, staticRenderFns } from "./LocalEventoForm.vue?vue&type=template&id=f74e0134"
import script from "./LocalEventoForm.vue?vue&type=script&lang=js"
export * from "./LocalEventoForm.vue?vue&type=script&lang=js"
import style0 from "./LocalEventoForm.vue?vue&type=style&index=0&id=f74e0134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports